import Modal from "@mui/material/Modal";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { default as ArrowDecrease, default as ArrowIncrease } from "../../assets/icons/arrow-increase.svg";
import Notification from "../../assets/icons/notification.svg";
import MarkAllRead from "../../assets/icons/tick-blue-circle.svg";
import BlueTick from "../../assets/icons/tick-blue.svg";
import { ReactComponent as BrandIcon } from "../../assets/newIcons/brandLogo.svg";
import { ReactComponent as BrandLogoIcon } from "../../assets/newIcons/brandLogoIcon.svg";
import { ReactComponent as CryptoBrandIcon } from "../../assets/newIcons/cryptoBrandLogo.svg";
import { ReactComponent as CryptoBrandLogoIcon } from "../../assets/newIcons/cryptoBrandLogoIcon.svg";
import Cross from "../../assets/newIcons/crossCircleIcon.svg";
import crossTick from "../../assets/newIcons/crossRedCircleIcon.svg";
import Dollar from "../../assets/newIcons/dollarWhiteIcon.svg";
import MenuCloseIcon from "../../assets/newIcons/menuCloseIcon.svg";
import MenuIcon from "../../assets/newIcons/menuIcon.svg";
import { ReactComponent as SearchIcon } from "../../assets/newIcons/searchIcon.svg";
import greenTick from "../../assets/newIcons/tickCircleIcon.svg";
import InfoBox from "../../reusableComponents/InfoBox";
import Tabination from "../../reusableComponents/Tabination";
import { clearPersistedData } from "../../store/configureStore";
import { setActiveAccount } from "../../store/reducers/accountSlice";
import { deAuthenticate } from "../../store/reducers/authSlice";
import "./MainHeader.scss";
// import {data} from "../../components/SearchBox/searchKeywords";
import greenDash from "../../assets/icons/greenDash.svg";
import sadFace from "../../assets/images/sadFace.svg";
import data from "../../layouts/pageLayout/Sidebar.js";
import { Button, Dropdown, Badge } from "antd";
import { TOGGLE_Brand } from "../../store/reducers/brandSlice.js";
import axios from "axios";
import { baseUrl } from "../../utils/apis";
import { BellOutlined } from "@ant-design/icons";
import { setUnreadCount } from "../../store/reducers/notificationSlice";
import { formatUSD } from "../../utils/helpers/string";
import { showNotification } from "../../utils/notificationService";
import { requestFirebaseToken, onForegroundMessage } from "../../utils/firebase";
import { stripHtml } from "../../utils/helpers/string";
import { saveFcmDeviceToken } from "../../utils/apis/user";

const MainHeader = ({
  headerName,
  theme,
  // setTheme,
  // toggleTheme,
  setActiveTab,
  tabItems,
  activeTab,
  resetClickEvent = () => { },
  onTabChange = false,
  showTabs,
  handleMenu,
  buttonRef,
  matches,
  sidebarStatus,
  setSidebarStatus,
  openSidebarWithDelay = () => { },
  closeSidebarWithDelay = () => { },
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchBar, setSearchBar] = useState(false);
  const [bellDropdown, setBellDropdown] = useState(false);
  const [profileDropdown, setProfileDropdown] = useState(false);
  const bellRef = useRef(null);
  const profileRef = useRef(null);
  const prevUnreadCountRef = useRef(-1);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const accountListValue = useSelector((state) => state?.account?.accountList);

  const [accountList, setAccountList] = useState(accountListValue);
  const idToken = useSelector((state) => state.auth.idToken);
  const userDetails = useSelector((state) => state.user);

  const unreadCount = useSelector((state) => state.notification.unreadCount);

  const fetchUnreadCount = async () => {
    if (!idToken) return;
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      };
      const response = await axios.get(`${baseUrl}/auth/notifications/unread-count/`, config);
      if (response.data && response.data.count !== undefined) {
        const newCount = response.data.count;

        // Update unread count gracefully in UI
        prevUnreadCountRef.current = newCount;
        dispatch(setUnreadCount(newCount));
      }
    } catch (error) {
      console.error("Error fetching unread count for header:", error);
    }
  };

  useEffect(() => {
    if (idToken) {
      // 1. Initialize Firebase and grab device token
      requestFirebaseToken().then((token) => {
        if (token) {
          // Send token to your backend API
          const deviceData = {
            registration_id: token,
            type: "web",
            name: "Web Browser",
            active: true,
          };
          saveFcmDeviceToken(idToken, deviceData)
            .then((res) => {
              console.log("FCM DEBUG: Device token saved successfully on load:", res);
            })
            .catch((err) => {
              console.error("FCM DEBUG: Error saving device token on load:", err);
            });
        } else {
          console.log("FCM DEBUG: No token available on mount (permission may not be granted yet).");
        }
      });

      // 2. Listen to active foreground push payloads
      onForegroundMessage((payload) => {
        // Automatically increment unread count from Redux
        const updatedCount = prevUnreadCountRef.current + 1;
        prevUnreadCountRef.current = updatedCount;
        dispatch(setUnreadCount(updatedCount));

        const title = payload.notification?.title || "New Message";
        const rawBody = payload.notification?.body || "You have a new notification";
        const body = stripHtml(rawBody);
        const tag = payload.fcmMessageId || payload.data?.notificationId || "fcm-notification";

        showNotification(title, {
          body: body,
          tag: tag,
          data: payload.data,
        });
      });

      // Fetch unread count once on mount instead of polling
      fetchUnreadCount();

      return () => {
        // Cleanup if needed
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idToken]);

  const handleProfileDropdown = () => {
    // dispatch(getAccountList(idToken));
    setBellDropdown(false);
    setProfileDropdown(!profileDropdown);
  };
  const handleProfileDropdownClose = () => {
    setProfileDropdown(false);
  };
  useEffect(() => {
    setAccountList(accountListValue);
  }, [accountListValue]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (bellRef.current && !bellRef.current.contains(event.target) && profileRef.current && !profileRef.current.contains(event.target)) {
        setBellDropdown(false);
        setProfileDropdown(false);
      }
    };

    window.addEventListener("click", handleClickOutside);
    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const [items, setItems] = useState([]);
  const [active, setActive] = useState(activeTab);
  const [none, setNone] = useState([1, 2, 3]);

  const [mobileMenu, setMobileMenu] = useState(false);

  function handleTab(e, idx) {
    if (setActiveTab) {
      setActiveTab(idx);
    }
    setActive(idx);
    resetClickEvent(false);
    setNone(none);
  }
  useEffect(() => {
    const handleTabChange = (activeTab) => {
      setActive(activeTab);
      resetClickEvent(false);
    };
    handleTabChange(activeTab);
  }, [activeTab]);

  useEffect(() => {
    setItems(tabItems);
  }, [tabItems]);
  const support = useSelector((state) => state.support);

  const [activeTabD, setActiveTabD] = useState("");

  const handleEmail = () => {
    const emailAddress = "support@equityedge.io";
    const subject = "Subject of the email";
    const body = "Body of the email";
    const mailtoLink = `mailto:${emailAddress}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  };

  const handleTabClick = (e) => {
    window.scrollTo(0, 0);
    setMobileMenu(false);
    setActiveTabD(e);
    if (e === "Support") {
      handleEmail();
    }
  };
  useEffect(() => { }, [activeTabD]);

  const location_path = useLocation();
  var pathnameSegments = location_path.pathname.split("/");
  var desiredPart = pathnameSegments[1];
  useEffect(() => {
    const currentLocation = "/" + desiredPart;

    //

    switch (currentLocation) {
      case "/":
        setActiveTabD("Dashboard");
        break;

      case "/account-metrics":
        setActiveTabD("Account Metrics");
        break;

      case "/funding-evaluation-payment":
        setActiveTabD("Payments");
        break;

      // Trading Cup
      // case "/tradingCup-leaderboard":
      //   setActiveTabD("Trading Cup");
      //   break;

      case "/evaluation":
        setActiveTabD("Buy Funded Account");
        break;

      case `/funding-evaluation`:
        setActiveTabD("Choose challenge");
        break;

      case "/trademate":
        setActiveTabD("Market Analysis");
        break;
      case "/trademate/economic-calendar":
        setActiveTabD("Market Analysis");
        break;
      case "/trademate/market-news":
        setActiveTabD("Market Analysis");
        break;

      case "/affiliate":
        setActiveTabD("Affiliate");
        break;
      case "/affiliate/get-a-link":
        setActiveTabD("Affiliate");
        break;

      case "/request-payout":
        setActiveTabD("Withdrawals");
        break;
      case "/request-payout/affiliate-payout":
        setActiveTabD("Withdrawals");
        break;

      case "/myprofile":
        setActiveTabD("Settings");
        break;

      case "/support-center":
        setActiveTabD("Support");
        break;

      case "/verification-kyc":
        setActiveTabD("KYC");
        break;
      case "/billing-details":
        setActiveTabD("Billing Details");
        break;
      case "/download":
        setActiveTabD("Download");
        break;

      case "/buy-funded":
        setActiveTabD("BuyFundedAccount");
        break;

      case "/Contract-list":
        setActiveTabD("Contract");
        break;

      case "/certificates":
        setActiveTabD("Certificates");
        break;

      default:
      // Handle default case here if needed
    }
  }, [window.location.pathname]);

  const handleLogout = () => {
    dispatch(deAuthenticate());
    clearPersistedData();
  };
  const [newData, setNewData] = useState([]);
  const [searchKeys, setSearchKeys] = useState(newData?.slice(0, 5));
  const [inputVal, setInputVal] = useState("");

  const [inputFocus, setInputFocus] = useState(false);

  useEffect(() => {
    if (accountList?.data?.length > 1) {
      setNewData(data); // Assuming `data` is `accountList.data`
    } else {
      setNewData(data?.filter((account) => account?.title !== "Account Metrics") || []);
    }
  }, [accountList, data]);

  useEffect(() => {
    setSearchKeys(newData.slice(0, 5));
  }, [newData]);

  const handleChange = (e) => {
    const value = e.target.value.toLowerCase();
    setInputVal(value);
    setSearchKeys(newData.filter((item) => item?.title?.toLowerCase().includes(value)));
  };
  const searchRef = useRef(null);
  const searchMaineRef = useRef(null);
  //
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target) && searchMaineRef.current && !searchMaineRef.current.contains(event.target)) {
        setInputFocus(false);
        setSearchActive(false);
        setInputVal("");
        setSearchKeys(newData?.slice(0, 5));
      }
    };

    window.addEventListener("click", handleClickOutside);
    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const [searchActive, setSearchActive] = useState(false);

  const [matchesScreen, setMatchesScreen] = useState(window.matchMedia("(min-width: 1100px) and (max-width: 2400px)").matches);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 1100px) and (max-width: 2400px)");
    const handleResize = (e) => setMatchesScreen(e.matches); // Use 'matches' instead of 'matchesScreen'

    // Attach the listener
    mediaQuery.addEventListener("change", handleResize);

    // Cleanup function
    return () => {
      mediaQuery.removeEventListener("change", handleResize);
    };
  }, []);

  const { selectedBrand } = useSelector((state) => state.brand);

  const itemss = [
    {
      key: "equity_edge",
      label: (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <BrandIcon className="brandTextIcon" />
          <BrandLogoIcon className="brandLogoIcon" />
          <svg
            width="30px"
            height="30px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g
              id="SVGRepo_bgCarrier"
              stroke-width="0"
            ></g>
            <g
              id="SVGRepo_tracerCarrier"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.7071 14.7071C12.3166 15.0976 11.6834 15.0976 11.2929 14.7071L6.29289 9.70711C5.90237 9.31658 5.90237 8.68342 6.29289 8.29289C6.68342 7.90237 7.31658 7.90237 7.70711 8.29289L12 12.5858L16.2929 8.29289C16.6834 7.90237 17.3166 7.90237 17.7071 8.29289C18.0976 8.68342 18.0976 9.31658 17.7071 9.70711L12.7071 14.7071Z"
                fill="#fff"
              ></path>{" "}
            </g>
          </svg>
        </div>
      ),
      buttonLabel: "Equity Edge",
      number: "#1",
    },
    {
      key: "crypto_edge",
      label: (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <CryptoBrandIcon className="brandTextIcon" />
          <CryptoBrandLogoIcon className="brandLogoIcon" />

          <svg
            width="30px"
            height="30px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g
              id="SVGRepo_bgCarrier"
              stroke-width="0"
            ></g>
            <g
              id="SVGRepo_tracerCarrier"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.7071 14.7071C12.3166 15.0976 11.6834 15.0976 11.2929 14.7071L6.29289 9.70711C5.90237 9.31658 5.90237 8.68342 6.29289 8.29289C6.68342 7.90237 7.31658 7.90237 7.70711 8.29289L12 12.5858L16.2929 8.29289C16.6834 7.90237 17.3166 7.90237 17.7071 8.29289C18.0976 8.68342 18.0976 9.31658 17.7071 9.70711L12.7071 14.7071Z"
                fill="#fff"
              ></path>{" "}
            </g>
          </svg>
        </div>
      ),
      buttonLabel: "Crypto Edge",
      number: "#2",
    },
  ];
  const [buttonText, setButtonText] = useState(itemss.find((item) => item.key === selectedBrand?.brand)?.label || "Select Team");

  useEffect(() => {
    const updatedLabel = itemss.find((item) => item.key === selectedBrand?.brand)?.label || "Select Team";
    setButtonText(updatedLabel);
  }, [selectedBrand?.brand]);

  const handleMenuClick = (e) => {
    const selectedItem = itemss.find((item) => item.key === e.key);
    setButtonText(selectedItem.label); // Use the buttonLabel property
    dispatch(TOGGLE_Brand(selectedItem?.key)); // Single dispatch call

    if (selectedItem?.key !== selectedBrand?.brand) {
      setTimeout(() => {
        if (window.location.pathname.includes("funding-evaluation") && window.location.pathname.includes("payments")) {
          navigate("/");
        } else {
          // Consider avoiding reload; update state
          window.location.reload();
        }
      }, 1000);
    }
  };

  const menuProps = {
    items: itemss.map((item) => ({
      ...item,
      label: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {item.buttonLabel}
        </div>
      ),
    })),
    onClick: handleMenuClick,
  };

  const brandTabItems = [
    { value: "equity_edge", name: "Equity Edge" },
    // { value: "futures_edge", name: "Futures Edge" },
    { value: "crypto_edge", name: "Crypto Edge" },
  ];

  const handleBrandSelector = (value) => {
    dispatch(TOGGLE_Brand(value)); // Single dispatch call
    setTimeout(() => {
      if (window.location.pathname.includes("funding-evaluation") && window.location.pathname.includes("payments")) {
        navigate("/");
      } else {
        // Consider avoiding reload; update state
        window.location.reload();
      }
    }, 500);
  };

  // Filter brandTabItems to exclude the currently selected brand
  const filteredBrandTabItems = brandTabItems.filter((item) => item.value !== selectedBrand?.brand);

  // console.log(filteredBrandTabItems, selectedBrand, "filteredBrandTabItems");

  console.log("unreadCount", unreadCount);

  return (
    <>
      <div className="mainHeaderContainer">
        <div className="mainHeaderWrapper">
          <div className={`header headerPC ${theme}`}>
            <div className="header_left_box">
              {matches ? (
                <div
                  className="menuIconBox cursorPointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleMenu(e); // Toggle the menu for small screens
                  }}
                >
                  {sidebarStatus ? (
                    <img
                      src={MenuCloseIcon}
                      className="menu-icon"
                      alt="Menu Close"
                    />
                  ) : (
                    <img
                      src={MenuIcon}
                      className="menu-icon"
                      alt="Menu"
                    />
                  )}
                </div>
              ) : matchesScreen ? (
                <div
                  className="menuIconBox cursorPointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    setSidebarStatus((prev) => !prev); // Toggle sidebar on click
                  }}
                >
                  <img
                    src={MenuIcon}
                    className="menu-icon"
                    alt="Menu"
                  />
                </div>
              ) : (
                <div
                  className="menuIconBox cursorPointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    setSidebarStatus(!sidebarStatus);
                  }}
                >
                  <img
                    src={MenuIcon}
                    className="menu-icon"
                    alt="Menu"
                  />
                </div> // Fallback for when neither condition is met
              )}
              {selectedBrand?.brand === "equity_edge" ? (
                <>
                  <BrandIcon className="brandTextIcon" />
                  <BrandLogoIcon className="brandLogoIcon" />
                </>
              ) : selectedBrand?.brand === "crypto_edge" ? (
                <>
                  <CryptoBrandIcon className="brandTextIcon" />
                  <CryptoBrandLogoIcon className="brandLogoIcon" />
                </>
              ) : (
                ""
              )}{" "}
              {/* <div className="logoBox">
                <Dropdown
                  menu={menuProps}
                  placement="right"
                >
                  <Button>{buttonText}</Button>
                </Dropdown>
              </div> */}
            </div>
            <div className="header_middle_box">
              <h2 className={`contentHeaderName ${theme === "dark-theme" ? "dark" : "light"}`}> {headerName}</h2>
            </div>
            <div className="header_right_box">
              {/* <div
                className="header_right"
                style={{ marginRight: "15px", display: "flex", gap: "10px", alignItems: "center", cursor: "pointer" }}
              >
                <Badge
                  count={unreadCount}
                  overflowCount={99}
                  onClick={() => navigate("/notification")}
                  style={{ cursor: "pointer" }}
                >
                  <BellOutlined style={{ fontSize: "28px", color: "#fff" }} />
                </Badge>
              </div> */}
              {/* <div
                ref={searchRef}
                className="search_main"
                style={{borderBottomLeftRadius: inputFocus ? "0" : "", borderBottomRightRadius: inputFocus ? "0" : ""}}
              >
                <div
                  className={`search-bar ${searchActive ? "activeSearchBox" : ""}`}
                  ref={searchMaineRef}
                >
                  <input
                    type="text"
                    className={`search_input ${searchActive ? "activeSearchInput" : ""}`}
                    placeholder="Search"
                    style={{backgroundColor: inputFocus ? "transparent !important" : ""}}
                    value={inputVal}
                    onChange={handleChange}
                    onFocus={(e) => (e.target.focus ? setInputFocus(true) : setInputFocus(false))}
                  />
                  <div
                    className={`search_icon ${searchActive ? "disableSearchIcon" : ""}`}
                    onClick={() => {
                      setSearchActive(!searchActive);
                      setInputFocus(false);
                    }}
                  >
                    <SearchIcon />
                  </div>
                </div>
                <div className={`search_value ${!inputFocus ? "hiddenSuggestion" : "activeSuggestion"}`}>
                  <p>Suggestions</p>
                  <div className="suggestionList">
                    {inputFocus &&
                      searchKeys?.map((item, index) => {
                        if (item.title === "Support") {
                          return (
                            <div
                              key={index}
                              onClick={() => {
                                const emailAddress = "support@equityedge.io";
                                const subject = "Subject of the email";
                                const body = "Body of the email";
                                const mailtoLink = `mailto:${emailAddress}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
                                window.location.href = mailtoLink;
                                // navigate(`${item.path}`);
                                setInputFocus(false);
                              }}
                              className="content_list"
                            >
                              {item.icon}
                              <span>{item.title}</span>
                            </div>
                          );
                        }
                        return (
                          <div
                            key={index}
                            onClick={() => {
                              navigate(`${item.path}`);
                              setInputFocus(false);
                            }}
                            className="content_list"
                          >
                            {item.icon}
                            <span>{item.title}</span>
                          </div>
                        );
                      })}
                    {searchKeys?.length === 0 && (
                      <div className="no_list">
                        <img
                          src={sadFace}
                          alt="dashboardsvg"
                        />
                        <span> Page Not Found</span>
                      </div>
                    )}
                  </div>
                </div>
              </div> */}
              {/* <div className="brand_tabs_wrapper">
                {filteredBrandTabItems.map((item) => (
                  <div
                    key={item.value}
                    className={`brand_tab tab_${item.value === "equity_edge" ? "equity_edge" : "crypto_edge"}`} // Added respective class name
                    onClick={() => handleBrandSelector(item.value)}
                  >
                    <p>Go To {item.name}</p>
                  </div>
                ))}
              </div>{" "} */}
              <div
                className={`profile_section cursorPointer ${profileDropdown === true ? "pfDropdownActive" : "pfDropdownInactive"}`}
                ref={profileRef}
                onClick={handleProfileDropdown}
              >
                <div className="profileBox">
                  <p className={`profileInitials ${profileDropdown ? "active_profile" : ""}`}>{userDetails?.first_name ? `${userDetails?.first_name?.charAt(0).toUpperCase()}` : ""}</p>
                  <p>
                    {`${userDetails?.first_name?.length > 16 ? userDetails?.first_name?.substring(0, 16) + "..." : userDetails?.first_name}`.length > 16
                      ? `${userDetails?.first_name?.substring(0, 16) + "..."}`
                      : userDetails?.first_name}
                  </p>
                </div>
                {profileDropdown && (
                  <Modal
                    open={profileDropdown}
                    onClose={handleProfileDropdownClose}
                  >
                    <ProfileDropdown
                      accountList={accountList}
                      profileDropdown={profileDropdown}
                      setProfileDropdown={setProfileDropdown}
                    />
                  </Modal>
                )}
              </div>
              {/* <div
                ref={bellRef}
                className="header_right"
              >
                <ul className="icons_list">
                  <div className="bell_icon">
                    <img
                      src={notificationBell}
                      alt=""
                      onClick={handleOpen}
                    />
                    <div
                      className="notification_modal"
                      style={{position: "relative"}}
                    >
                      <Modal
                        className="modal_box"
                        aria-labelledby="transition-modal-title"
                        aria-describedby="transition-modal-description"
                        open={open}
                        onClose={handleClose}
                        closeAfterTransition
                        slots={{backdrop: Backdrop}}
                        slotProps={{
                          backdrop: {
                            timeout: 500,
                          },
                        }}
                      >
                        <Fade in={open}>
                          <Box sx={style}>
                            <Typography
                              id="transition-modal-title"
                              variant="h6"
                              component="h2"
                            >
                              <div className="notification_box">
                                <h1>Notification Box</h1>
                              </div>
                            </Typography>
                            <Typography
                              id="transition-modal-description"
                              sx={{mt: 2}}
                            >
                              Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
                            </Typography>
                          </Box>
                        </Fade>
                      </Modal>
                    </div>
                  </div>
                  <div
                    className="moon_icon"
                    onClick={() => navigate("/myprofile")}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                    >
                      <path
                        d="M19.3501 7.92383L18.9841 7.71983C18.662 7.55396 18.391 7.30372 18.2001 6.99583C18.1831 6.96883 18.1671 6.93983 18.1351 6.88383C17.9196 6.53771 17.8149 6.13405 17.8351 5.72683L17.8411 5.30183C17.8531 4.62183 17.8591 4.27983 17.7631 3.97383C17.6782 3.70154 17.536 3.45059 17.3461 3.23783C17.1321 2.99783 16.8351 2.82583 16.2401 2.48383L15.7461 2.19883C15.1541 1.85783 14.8571 1.68683 14.5421 1.62183C14.2638 1.56421 13.9764 1.5666 13.6991 1.62883C13.3861 1.69883 13.0931 1.87483 12.5081 2.22483L12.5051 2.22683L12.1511 2.43783C12.0951 2.47183 12.0661 2.48783 12.0381 2.50383C11.7601 2.65883 11.4501 2.74383 11.1311 2.75383C11.0991 2.75583 11.0661 2.75583 11.0011 2.75583L10.8711 2.75483C10.552 2.74478 10.2399 2.65836 9.96108 2.50283C9.93308 2.48783 9.90608 2.47083 9.85008 2.43683L9.49308 2.22283C8.90408 1.86883 8.60908 1.69283 8.29408 1.62183C8.01574 1.55946 7.72727 1.55742 7.44808 1.61583C7.13208 1.68183 6.83608 1.85383 6.24308 2.19783L6.24008 2.19883L5.75208 2.48183L5.74708 2.48583C5.15908 2.82583 4.86408 2.99783 4.65208 3.23683C4.46316 3.44922 4.32168 3.69945 4.23708 3.97083C4.14208 4.27783 4.14708 4.61983 4.15908 5.30383L4.16608 5.72783C4.16608 5.79283 4.16908 5.82483 4.16808 5.85583C4.1628 6.21913 4.05875 6.57415 3.86708 6.88283C3.83408 6.93883 3.81908 6.96683 3.80208 6.99283C3.63347 7.265 3.40198 7.49271 3.12708 7.65683L3.01508 7.71983L2.65408 7.91983C2.05208 8.25283 1.75108 8.41983 1.53308 8.65783C1.33926 8.86766 1.19264 9.11658 1.10308 9.38783C1.00308 9.69483 1.00308 10.0378 1.00408 10.7258L1.00608 11.2888C1.00708 11.9718 1.00908 12.3128 1.11008 12.6178C1.19926 12.8874 1.34483 13.1349 1.53708 13.3438C1.75508 13.5798 2.05308 13.7458 2.65008 14.0778L3.00808 14.2768C3.06908 14.3108 3.10008 14.3268 3.12908 14.3448C3.44245 14.5327 3.69838 14.8028 3.86908 15.1258L3.93608 15.2458C4.10499 15.5647 4.18447 15.9234 4.16608 16.2838L4.15908 16.6908C4.14708 17.3768 4.14208 17.7208 4.23808 18.0278C4.32308 18.2998 4.46508 18.5508 4.65508 18.7638C4.86908 19.0038 5.16708 19.1748 5.76108 19.5178L6.25508 19.8028C6.84808 20.1438 7.14408 20.3148 7.45908 20.3798C7.73738 20.4374 8.02477 20.435 8.30208 20.3728C8.61608 20.3028 8.90908 20.1268 9.49608 19.7748L9.85008 19.5628C10.155 19.3665 10.5076 19.2569 10.8701 19.2458H11.1301C11.4481 19.2558 11.7601 19.3428 12.0401 19.4978L12.1321 19.5528L12.5081 19.7788C13.0981 20.1328 13.3921 20.3088 13.7071 20.3788C13.9853 20.4418 14.2737 20.4445 14.5531 20.3868C14.8681 20.3208 15.1661 20.1478 15.7591 19.8038L16.2541 19.5168C16.8421 19.1748 17.1371 19.0038 17.3491 18.7648C17.5391 18.5518 17.6791 18.3018 17.7641 18.0308C17.8591 17.7258 17.8541 17.3868 17.8421 16.7128L17.8341 16.2728C17.8142 15.8663 17.9189 15.4633 18.1341 15.1178L18.1991 15.0078C18.3677 14.7357 18.5992 14.5079 18.8741 14.3438L18.9841 14.2828L18.9861 14.2818L19.3471 14.0818C19.9491 13.7478 20.2501 13.5818 20.4691 13.3438C20.6631 13.1338 20.8091 12.8838 20.8981 12.6138C20.9981 12.3088 20.9981 11.9668 20.9961 11.2868L20.9941 10.7128C20.9931 10.0298 20.9921 9.68783 20.8911 9.38283C20.8014 9.11356 20.6555 8.86643 20.4631 8.65783C20.2461 8.42183 19.9481 8.25583 19.3521 7.92483L19.3501 7.92383Z"
                        stroke="#526C7B"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7 11.0009C7 12.0617 7.42143 13.0791 8.17157 13.8293C8.92172 14.5794 9.93913 15.0009 11 15.0009C12.0609 15.0009 13.0783 14.5794 13.8284 13.8293C14.5786 13.0791 15 12.0617 15 11.0009C15 9.93999 14.5786 8.92257 13.8284 8.17243C13.0783 7.42228 12.0609 7.00085 11 7.00085C9.93913 7.00085 8.92172 7.42228 8.17157 8.17243C7.42143 8.92257 7 9.93999 7 11.0009Z"
                        stroke="#526C7B"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </ul>
              </div> */}
            </div>
          </div>
          {/* <div className={"headerTabination headerPC " + activeTabD}>
            {showTabs && (
              <>
                <div className="headerTabination-TabCon">
                  {items?.map((item, index) => {
                    return (
                      <li
                        key={index}
                        onClick={(e) => handleTab(e, index)}
                      >
                        <Link
                          to={item?.path}
                          className="headerTabs"
                        >
                          <span className={index === active ? "tabination-toggle" : ""}>{item["name"]}</span>
                        </Link>
                      </li>
                    );
                  })}
                </div>
                <div className="headerActiveTabline"></div>
              </>
            )}
          </div> */}
          {/* <div className="phoneHeader">
            <div className="phoneHeader-T">
              <div className="phoneHeader-T-L">
                <img
                  src={"EELogo"}
                  alt="logo"
                />
              </div>

              <div
                className="phoneHeader-T-R"
                onClick={() => {
                  setMobileMenu(!mobileMenu);
                }}
              >
                <div>
                  {" "}
                  {!mobileMenu ? (
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.9998 2.66699C14.2489 2.66699 12.5151 3.01187 10.8974 3.68193C9.27972 4.35199 7.80986 5.33412 6.57175 6.57223C4.07126 9.07272 2.6665 12.4641 2.6665 16.0003C2.6665 19.5365 4.07126 22.9279 6.57175 25.4284C7.80986 26.6665 9.27972 27.6487 10.8974 28.3187C12.5151 28.9888 14.2489 29.3337 15.9998 29.3337C19.5361 29.3337 22.9274 27.9289 25.4279 25.4284C27.9284 22.9279 29.3332 19.5365 29.3332 16.0003C29.3332 14.2494 28.9883 12.5156 28.3182 10.8979C27.6482 9.2802 26.666 7.81035 25.4279 6.57223C24.1898 5.33412 22.72 4.35199 21.1023 3.68193C19.4846 3.01187 17.7508 2.66699 15.9998 2.66699ZM7.99984 9.33366H23.9998V12.0003H7.99984V9.33366ZM7.99984 14.667H23.9998V17.3337H7.99984V14.667ZM7.99984 20.0003H23.9998V22.667H7.99984V20.0003Z"
                        fill="#36D66B"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.1998 22.667L15.9998 17.867L20.7998 22.667L22.6665 20.8003L17.8665 16.0003L22.6665 11.2003L20.7998 9.33366L15.9998 14.1337L11.1998 9.33366L9.33317 11.2003L14.1332 16.0003L9.33317 20.8003L11.1998 22.667ZM15.9998 29.3337C14.1554 29.3337 12.4221 28.9834 10.7998 28.283C9.17762 27.5825 7.7665 26.6328 6.5665 25.4337C5.3665 24.2337 4.41673 22.8225 3.71717 21.2003C3.01762 19.5781 2.66739 17.8448 2.6665 16.0003C2.6665 14.1559 3.01673 12.4225 3.71717 10.8003C4.41762 9.1781 5.36739 7.76699 6.5665 6.56699C7.7665 5.36699 9.17762 4.41721 10.7998 3.71766C12.4221 3.0181 14.1554 2.66788 15.9998 2.66699C17.8443 2.66699 19.5776 3.01721 21.1998 3.71766C22.8221 4.4181 24.2332 5.36788 25.4332 6.56699C26.6332 7.76699 27.5834 9.1781 28.2838 10.8003C28.9843 12.4225 29.3341 14.1559 29.3332 16.0003C29.3332 17.8448 28.9829 19.5781 28.2825 21.2003C27.5821 22.8225 26.6323 24.2337 25.4332 25.4337C24.2332 26.6337 22.8221 27.5839 21.1998 28.2843C19.5776 28.9848 17.8443 29.3345 15.9998 29.3337Z"
                        fill="#36D66B"
                      />
                    </svg>
                  )}
                </div>
              </div>
            </div>
            <div className={"phoneHeader-B " + (mobileMenu && " active ")}>
              <div className="mobile_menu">
                {SidebarData.map((item, index) => (
                  <>
                    <Link
                      to={item.path}
                      id={item.title}
                      className={activeTabD === item.title ? "active" : ""}
                      onClick={() => {
                        handleTabClick(item.active);
                      }}
                    >
                      {item.icon}
                      {item.title}
                    </Link>
                  </>
                ))}
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default MainHeader;

const BellDropdown = ({ bellDropdown, setBellDropdown }) => {
  const items = [
    { name: "View All", content: "" },
    { name: "By Company", content: "" },
  ];

  return (
    <div
      className="dropdown dropdown_bell"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div className="dropdown_header">
        <h2>Notifications</h2>
        <img
          src={Cross}
          alt="cross icon"
          onClick={() => setBellDropdown(!bellDropdown)}
        />
      </div>
      <div className="notifications_tabs">
        <Tabination
          variant={4}
          tabItems={items}
        />
      </div>
      <div className="notifications_wrapper">
        <div className="notification">
          <div>
            <img
              className="notification_icon"
              src={Notification}
              alt="notification"
            />
          </div>
          <div className="notification_content">
            <div className="notification_content_upper">
              <p>
                <span>Company Accepted</span> your case Account & Billing Support & other
              </p>
            </div>
            <div className="notification_content_bottom">
              <span className="time">Friday 2:20pm</span>
              <span className="date">31 Jan 2021</span>
            </div>
          </div>
        </div>
        <div className="notification">
          <div>
            <img
              src={Notification}
              alt="notification"
            />
          </div>
          <div className="notification_content">
            <div className="notification_content_upper">
              <p>
                <span>Company Accepted</span> your case Account & Billing Support & other
              </p>
            </div>
            <div className="notification_content_bottom">
              <span className="time">Friday 2:20pm</span>
              <span className="date">31 Jan 2021</span>
            </div>
          </div>
        </div>
      </div>

      <div className="dropdown_footer">
        <div className="dropdown_footer_bell">
          <div className="dropdown_footer_left">
            <img
              src={MarkAllRead}
              alt="tick icon"
            />
            <p>Mark all as read</p>
          </div>
          <div className="dropdown_footer_right">
            <button className="view_all_btn">View all notifications</button>
          </div>
        </div>
      </div>
    </div>
  );
};

const ProfileDropdown = ({ profileDropdown, setProfileDropdown, accountList }) => {
  const navigate = useNavigate();
  const inProgressAccounts = (accountList?.data || []).filter((account) => account?.status === "in_progress");
  const [login_id, setLogin_id] = useState(inProgressAccounts);
  const [active, setActive] = useState("All");

  useEffect(() => {
    if (accountList?.data) {
      if (active === "All") {
        setLogin_id(accountList.data);
      } else {
        const filterData = accountList.data.filter((ele, ind) => ele.challenge === active);
        setLogin_id(filterData);
      }
    }
  }, [accountList, active]);

  const loginFilter = (e) => {
    if (e === "All") {
      setLogin_id(inProgressAccounts);
    } else {
      const filterData = inProgressAccounts.filter((ele) => ele.challenge === e);
      setLogin_id(filterData);
    }
    setActive(e);
  };
  const handleLogout = () => {
    dispatch(deAuthenticate());
    clearPersistedData();
  };
  const dispatch = useDispatch();
  const active_id = useSelector((state) => state.account.accountList?.selectedAccount?.login_id?.replace("%23", "#"));

  const accountsData = useSelector((state) => state.account.accountMetrics);
  let infoBoxArr = [
    {
      title: "Account Balance",
      value: accountsData?.data?.balance_equity?.balance ? formatUSD(accountsData?.data?.balance_equity?.balance) : "na",
      icon: ArrowIncrease,
      percentage: "+2.53%",
      color: "#F75C03",
    },
    {
      title: "Equity",
      value: accountsData?.data?.balance_equity?.equity ? formatUSD(accountsData?.data?.balance_equity?.equity) : "na",
      icon: ArrowDecrease,
      percentage: "-1.2%",
      color: "#4CB944",
    },
  ];
  const [Ametrics, setAmetrics] = useState([]);
  useEffect(() => {
    setAmetrics(accountsData.data);
  }, [accountsData]);

  const userDetails = useSelector((state) => state.user);
  const uniqueChallenges = [...new Set(inProgressAccounts.map((account) => account.challenge))]
    .filter(Boolean)
    .sort((a, b) => {
      const regex = /^([\d.]+)(K|M|B)?\s*(.*)$/i;
      const matchA = String(a).match(regex);
      const matchB = String(b).match(regex);

      if (matchA && matchB) {
        const numA = parseFloat(matchA[1]);
        const numB = parseFloat(matchB[1]);
        const multA = matchA[2]?.toUpperCase() === "K" ? 1000 : matchA[2]?.toUpperCase() === "M" ? 1000000 : 1;
        const multB = matchB[2]?.toUpperCase() === "K" ? 1000 : matchB[2]?.toUpperCase() === "M" ? 1000000 : 1;
        const valA = numA * multA;
        const valB = numB * multB;

        if (valA !== valB) {
          return valA - valB;
        }
        return matchA[3].localeCompare(matchB[3]);
      }
      if (matchA) return -1;
      if (matchB) return 1;
      return String(a).localeCompare(String(b));
    });

  const startingBalance = Ametrics?.starting_balance || 0; // Assuming starting_balance is a number

  const formattedBalance = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    // minimumFractionDigits: 2,
  }).format(startingBalance);
  // LOADER LOGIC
  const accountMetrics = useSelector((state) => state.account.accountMetrics);
  const [isLoading, setIsLoading] = useState(accountMetrics.loading);
  const [errorModalOpen, setErrorModalOpen] = useState(accountMetrics.error);

  useEffect(() => {
    setIsLoading(accountMetrics.loading);
  }, [accountMetrics.loading]);

  return (
    <div
      className={`dropdown dropdown_profile`}
      onClick={(e) => {
        setProfileDropdown(!profileDropdown);
      }}
    >
      {/* {(isLoading ) && <LoaderOverlay desc= {accountMetrics.error && accountMetrics.message} />} */}
      <div
        className="dropdown_wrapper"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="dropdown_header">
          <p>Profile</p>
          <img
            src={Cross}
            alt="cross icon"
            onClick={(e) => {
              e.stopPropagation();
              setProfileDropdown(!profileDropdown);
            }}
            className="cross_icon cursorPointer"
          />
        </div>

        <div className="dropdown_profile_content">
          <div className="profile_details">
            <div className="profile_div">
              <div className="profile_img_wrapper">
                <p className={``}>{`${userDetails?.first_name?.charAt(0).toUpperCase() + " " + userDetails?.last_name?.charAt(0).toUpperCase()}`}</p>
              </div>
              <div className="profile_details_content">
                <h4>
                  {`${userDetails?.first_name?.length > 16 ? userDetails?.first_name.substring(0, 16) + "..." : userDetails.first_name} ${userDetails?.last_name?.length > 16 ? userDetails?.last_name.substring(0, 16) + "..." : userDetails?.last_name
                    }`.length > 16
                    ? `${userDetails?.first_name?.substring(0, 16) + "..."}`
                    : userDetails?.first_name + " " + userDetails?.last_name}
                </h4>
                <p>{active_id}</p>
              </div>
            </div>

            <div className="edit_img_wrapper">
              <Link
                to="/myprofile"
                onClick={(e) => {
                  setProfileDropdown(false);
                }}
              >
                <p>View Details</p>
              </Link>
            </div>
          </div>
          <div className="info_box_container pfDropdownInfoBox">
            {infoBoxArr?.map((info, idx) => (
              <InfoBox
                key={info.title}
                title={info.title}
                value={info.value}
                variant={2}
                color={info.color}
                idx={idx}
              />
            ))}
          </div>
          <div className="accounts_type_wrapper">
            <div className="accntTypeSelector">
              <p>Account Type</p>
              <ul className="account_type">
                <li
                  onClick={() => loginFilter("All")}
                  style={{ color: "rgba(13, 45, 68, 0.45))" }}
                >
                  {active === "All" ? (
                    <img
                      key="all-active-tick"
                      src={greenTick}
                      className={active !== "All" ? "imgActive" : ""}
                      alt="aggressive account"
                      style={{ height: "18px", width: "18px" }}
                    />
                  ) : (
                    <img
                      key="all-inactive-tick"
                      src={Dollar}
                      className={active !== "All" ? "imgActive" : ""}
                      alt="aggressive account"
                      style={{ height: "18px", width: "18px" }}
                    />
                  )}
                  All
                  {active === "All" ? (
                    <img
                      key="all-blue-tick"
                      className="blue_tick_icon"
                      src={BlueTick}
                      alt="tick icon"
                      style={{ height: "18px", width: "18px" }}
                    />
                  ) : null}
                </li>
                {uniqueChallenges.map((challenge) => (
                  <li onClick={() => loginFilter(challenge)}>
                    <img
                      key={`${challenge}-tick`}
                      className={active !== challenge ? "imgActive" : ""}
                      src={active !== challenge ? Dollar : greenTick}
                      alt="aggressive account"
                      style={{ height: "18px", width: "18px" }}
                    />
                    {challenge}
                    {active === challenge ? (
                      <img
                        key={`${challenge}-blue-tick`}
                        className="blue_tick_icon"
                        src={BlueTick}
                        alt="tick icon"
                        style={{ height: "18px", width: "18px" }}
                      />
                    ) : null}
                  </li>
                ))}
              </ul>
            </div>
            <div className="accntidSelector">
              <p>Active Accounts</p>
              <ul className="live_account_type">
                {login_id?.length <= 0
                  ? "No data"
                  : login_id?.map((ele, ind) => (
                    <li
                      key={ind}
                      onClick={() => {
                        dispatch(
                          setActiveAccount({
                            login_id: ele?.login_id?.replace("%23", "#"),
                            trading_platform: ele?.trading_platform,
                            email: ele?.email,
                          }),
                        );

                        setTimeout(() => {
                          navigate(`/account-metrics/program-objectives`);
                          setProfileDropdown(false);
                        }, 500);
                      }}
                      className={`${active_id === ele.login_id ? "active" : "disabled"}`}
                    >
                      {active_id === ele.login_id ? (
                        <img
                          key="active-tick"
                          className="blue_tick_icon"
                          src={greenDash}
                          alt="tick icon"
                          style={{ height: "18px", width: "18px" }}
                        />
                      ) : (
                        <img
                          key="disabled-tick"
                          className="blue_tick_icon"
                          src={crossTick}
                          alt="tick icon"
                          style={{ height: "18px", width: "18px" }}
                        />
                      )}
                      {ele.login_id}
                      {active_id === ele.login_id && (
                        <img
                          key="blue-tick"
                          className="blue_tick_icon"
                          src={BlueTick}
                          alt="tick icon"
                          style={{ height: "18px", width: "18px" }}
                        />
                      )}
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="dropdown_footer">
          <button
            className="logout-btn"
            onClick={handleLogout}
          >
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
};
